import {Component, Inject, OnInit} from "@angular/core";
import {UntypedFormBuilder} from "@angular/forms";
import {DeviceSlotId, ProjectId} from '@webmate-web-core/shared/types/ids';
import {DeviceSlot} from "@webmate-web-core/shared/types/devices/device-slot";
import {DeviceSlotService} from "@webmate-web-core/shared/services/device/device-slot.service";
import {WmNotificationService} from '@webmate-web-core/shared/components/notification/wm-notification.service';
import {ModalToolContainerService, WebmateToolConfig} from '../modaltoolcontainer/modaltoolcontainer.service';
import {TOOL_CONTAINER_DATA} from '../modaltoolcontainer/modaltoolcontainer.component';
import {UntilDestroy} from '@ngneat/until-destroy';
import { faInfoCircle } from "@fortawesome/pro-solid-svg-icons";


export class SlotMalfunctionReporterToolConfig implements WebmateToolConfig {
    toolName = "Slot Malfunction Reporter";

    constructor(public slotId: DeviceSlotId, public projectId: ProjectId) {
    }
}

interface SlotReporterMalfunctionReporterFormParams {
    message: string;
}

@UntilDestroy()
@Component({
    selector: "wm-slot-malfunction-reporter",
    templateUrl: "./slot-malfunction-reporter.component.html",
    styleUrls: ['./slot-malfunction-reporter.component.less']
})
export class SlotMalfunctionReporterComponent implements OnInit {

    faInfoCircle = faInfoCircle;

    reportTitle: string = "";
    message: string = "";
    deviceSlot?: DeviceSlot = undefined;
    logoSrc?: string = undefined;
    busySendingReport = false;
    private readonly ISSUEREPORTER_LOCALSTORAGE_KEY = "slot-malfunction-reporter_defaults";

    constructor(private fb: UntypedFormBuilder,
                @Inject(TOOL_CONTAINER_DATA) public data: SlotMalfunctionReporterToolConfig,
                private notificationService: WmNotificationService,
                private deviceSlotService: DeviceSlotService,
                private toolService: ModalToolContainerService) {
    }

    ngOnInit() {
        this.deviceSlotService.getSlotInProject$(this.data.slotId, this.data.projectId).subscribe(slot => {
            this.deviceSlot = slot;
        });
    }

    reportMalfunction() {
        this.busySendingReport = true
        this.deviceSlotService.sendMalfunctionReportOfSlot$(this.data.slotId, this.reportTitle, this.message, this.data.projectId).subscribe(
            next => {
                setTimeout(() => this.toolService.closeLastTool(), 0)
                this.notificationService.toastNotification("Malfunction Report sent successfully! We will contact you soon.");
            },
            err => {
                setTimeout(() => this.toolService.closeLastTool(), 0)
                this.notificationService.toastWarningNotification("Sending Malfunction Report failed!");
            }
        );
    }
}
